import { render, staticRenderFns } from "./LanguageBadgeList.vue?vue&type=template&id=f7df15dc&scoped=true&"
import script from "./LanguageBadgeList.vue?vue&type=script&lang=js&"
export * from "./LanguageBadgeList.vue?vue&type=script&lang=js&"
import style0 from "./LanguageBadgeList.vue?vue&type=style&index=0&id=f7df15dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7df15dc",
  null
  
)

export default component.exports